// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"972e7d80","453":"627c4d61","470":"36219395","770":"95b9050f","808":"9113b54a"}[chunkId] + ".chunk.js";
};